module.exports = __webpack_public_path__ + "img/panel_caution.c6127a79.svg";